export default __webpack_public_path__ + "static/media/rendering-cad.9bdef45e.png";